<template>
  <div class="PhoneFindPwd">
      <div class="" v-if="step === 1">
        <!-- 手机号码 -->
        <div class="field-input login-phone">
            <div class="phone-label" :class="telprex ? '' : 'label-font'" @click="selectPhoneRoaming" dir="ltr">
                <i class="fas fa-mobile-alt icon-color f16"></i>
                {{telprex ? "+" + telprex : $t('forgotPwd.global_roaming')}}
                <img src="../../../assets/imgs/login/down.png" />
            </div>
            <van-field
                v-model.trim="phone"
                :name="$t('forgotPwd.phone_number')"
                clearable
                class="phone-value"
                clear-trigger="always"
                :placeholder="$t('forgotPwd.phone_number')" 
                @touchstart="handleForceFocus('phoneInput')"
                ref="phoneInput"
            />
        </div>
          <van-button class="login-btn" :disabled="!phone" round block type="info" @click="next(1)">{{ $t('forgotPwd.next') }}</van-button>
      </div>
      <!--  -->
      <div v-if="step === 2">
          <div class="tips1">
              {{$t('forgotPwd.verification_code_has_been_sent')}}
              <span dir="ltr">{{ "+" + telprex + ' ' + phone }}</span>
          </div>
          <van-field
              v-model.trim="verificationCode"
              :name="$t('forgotPwd.verification_code')"
              clearable
              class="field-input"
              clear-trigger="always"
              :placeholder="$t('forgotPwd.verification_code')" 
              @touchstart="handleForceFocus('verifCodeInput')"
              ref="verifCodeInput"
          >
            <template #left-icon>
              <i class="fas fa-key icon-color f16"></i>
            </template>
          </van-field>
          <div class="tips2">
              {{$t('forgotPwd.no_verification_code_received')}}
              <span v-if="countdown <= 0" class="forgotPwd-resend" @click="handlerSend()">{{$t('forgotPwd.resend')}}</span>
              <span v-else>{{$t('forgotPwd.resend')}}（{{countdown}}s）</span>
          </div>
          <van-button class="login-btn" :disabled="!verificationCode" round block type="info" @click="next(2)">{{ $t('forgotPwd.next') }}</van-button>
      </div>
      <!--  -->
      <div v-if="step === 3">
          <div class="tips1">
              {{$t('forgotPwd.reset_password')}}
          </div>
           <!-- 密码 -->
            <van-field 
                v-model.trim="password" 
                :type="isShowPwd ? 'text' : 'password'" 
                :name="$t('registerlogin.password')"
                class="field-input"
                :error="!!password && !pwdPattern.test(password)"
                :placeholder="$t('registerlogin.password')" 
                @click-right-icon="handlerShowPwd"
                @touchstart="handleForceFocus('password')"
                ref="password"
            >
                <template #left-icon>
                  <i class="fas fa-lock icon-color f16"></i>
                </template>
                <template #right-icon>
                    <img v-if="password" :src="isShowPwd ? eye_fill : eye_close" alt="" class="field-right-img">
                </template>
            </van-field>
          <div class="tips2" :class="!pwdPattern.test(password) && password ? 'error' : ''">
              {{$t('forgotPwd.please_enter')}}
          </div>
          <van-button class="login-btn" :disabled="!password" round block type="info" @click="resetPassword">{{ $t('forgotPwd.reset_password') }}</van-button>
      </div>
      <!-- 国际区号选择弹窗 -->
      <van-popup v-model="roamingCodeShow" round position="bottom" custom-style="height: 30%">
        <van-picker 
            show-toolbar 
            :columns="getApiCountryData" 
            @cancel="roamingCodeShow = false" 
            @confirm="onConfirmRoaming" 
            value-key="text" 
            :confirm-button-text="$t('registerlogin.confirm')"
            :cancel-button-text="$t('registerlogin.cancel')"
            item-height="6.5vh" />
      </van-popup>
  </div>
</template>

<script>
import { Popup, Picker,} from "vant";
import eye_close from '../../../assets/imgs/login/eye_close.png'
import eye_fill from '../../../assets/imgs/login/eye_fill.png'
import md5 from 'js-md5';
export default {
    name:'PhoneFindPwd',
    components: {
        vanPopup: Popup,
        vanPicker: Picker,
    },
    props:{
        queryObj:{
            type:Object,
            default: () => ({})
        }
    },
    data() {
        return {
            phone:'',
            step:1,
            countdown: 60,
            roamingCodeShow: false,
            telprex:'',
            getApiCountryData:[],
            verificationCode:'',
            password:'',
            isShowPwd:false,
            eye_close,
            eye_fill,
            pwdPattern: /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?？。，；‘’“”：<>《》{}~`]{6,20}$/,
            iso2List:[],
        }
    },
    computed:{
    },
    mounted() {
    //   this.httpcountryGroup();
      this.httpGetEnterpriseConfigList();
      this.telprex = this.queryObj.telprex;
    },
    methods: {
        // 打开国际区号选择
        selectPhoneRoaming() {
            this.roamingCodeShow = true;
        },
        // 确认区号选择
        onConfirmRoaming(value,index) {
            this.roamingCodeShow = false;
            this.telprex = value.telprex
        },
        // 接口获取分站信息
        httpGetEnterpriseConfigList(){
            this.$http
            .post({
            url: "/bss/app/noauth/queryEnterpriseConfigList",
            data: {
                partnerCode: "MAYA",
                enterpriseCode: this.queryObj?.enterpriseCode,
            },
            auth:false,
            })
            .then((res) => {
            if(res.data && res.data.length){
                res.data.forEach((item) => {
                if(item.iso2List && item.iso2List.length){
                    this.iso2List = this.iso2List.concat(item.iso2List);
                }
                })
            }
            this.httpcountryGroup();
            })
            .catch((err) => {
            console.log(err);
            this.$toast(err);
            });
        },
        // 接口获取国家
        httpcountryGroup() {
        this.$http
            .post({
            url: "/bss/app/noauth/QueryCoverCountyInfo",
            data: {
                partnerCode: "MAYA",
                // coverFlag: "SHOW",
            },
            auth:false,
            })
            .then((res) => {
            if (res.data) {
                if(this.iso2List.includes('ALL')){
                    this.getApiCountryData = res.data.filter((item) => {
                        return item.iso2 !== 'ALL' && item.telprex
                    }).map((item) =>　{
                        return {
                            ...item,
                            text:item.countryName + " +" + item.telprex,
                            value:item.iso2
                        }
                    });
                } else {
                    this.getApiCountryData = res.data.filter((item) => {
                        return item.iso2 !== 'ALL' && item.telprex && this.iso2List.includes(item.iso2)
                    }).map((item) =>　{
                        return {
                            ...item,
                            text:item.countryName + " +" + item.telprex,
                            value:item.iso2
                        }
                    });
                }
            }
            })
            .catch((err) => {
            console.log(err);
            this.$toast(err);
            });
        },
        next(type) {
            switch (type) {
                case 1:
                    this.handlerSend(() => {this.step++})
                    break;
                case 2:
                    this.checkVerificationCode(() => {this.step++})
                    break;
            }
        },
        // 校验验证码是否正确
        checkVerificationCode(success) {
            this.$http
            .post({
                url: "/bss/dsds/noauth/VerifyVerificationCodeFromDSDS",
                data: {
                    phone: this.phone,
                    nationNum: this.telprex,
                    businessType: '2',
                    msgCode: this.verificationCode,
                    enterpriseCode: this.queryObj?.enterpriseCode
                },
                auth:false
            })
            .then((res) => {
                success && success()
            })
            .catch((err) => {
                console.log(err);
                this.$toast(err);
            });
        },
        // 切换密码框
        handlerShowPwd(){
            this.isShowPwd = !this.isShowPwd
        },
        // 重置密码
        resetPassword() {
            if(this.pwdPattern.test(this.password)){
                this.$http
                .post({
                    url: "/bss/app/noauth/ResetPasswordBySMS",
                    data: {
                        userCode: this.telprex + this.phone,
                        password: md5(this.password),
                        randomKey: this.verificationCode,
                        enterpriseCode: this.queryObj?.enterpriseCode
                    },
                    auth:false,
                })
                .then((res) => {
                    this.$router.go(-1)
                    this.$toast(this.$t('forgotPwd.reset_successful'))
                })
                .catch((err) => {
                    console.log(err);
                    this.$toast(err);
                });
            }
        },
        handlerSend(success) {
            this.$http
            .post({
                url: "/bss/app/noauth/GetVerificationCodeBySMS",
                data: {
                    phone: this.phone,
                    nationNum: this.telprex,
                    businessType: '2',
                    msgTemplateCode:'sms_verification_code_template',
                    enterpriseCode: this.queryObj?.enterpriseCode
                },
                auth:false,
            })
            .then((res) => {
                success && success()
                this.startCountdown(res?.data?.expireTime)
            })
            .catch((err) => {
                console.log(err);
                this.$toast(err);
            });

            // 神策-点击发送验证码
            this.$sensors.track('WebGetCodeClick', {
                service_type: '找回密码',
                get_type: '手机号',
                account: this.telprex + this.phone,
            });
        },
        // 启动倒计时
        startCountdown(expireTime) {
            // 1. 避免重复点击
            if (this.isCounting) return;

            // 2. 初始化状态
            this.isCounting = true;
            this.countdown = 60;

            // 4. 启动计时器
            this.timer = setInterval(() => {
                if (this.countdown <= 1) {
                this.stopCountdown()
                return
                }
                this.countdown--
            }, 1000)
        },

        // 停止倒计时
        stopCountdown() {
            clearInterval(this.timer)
            this.isCounting = false
            this.countdown = 0
        },

        // 输入框获取焦点
        handleForceFocus(ref) {
            this.$refs[ref].focus();
        },
    },
    
    // 组件销毁时清理定时器
    beforeDestroy() {
        this.stopCountdown()
    },
}
</script>

<style lang="less" scoped>
.PhoneFindPwd {
    font-family: Source Han Sans;
    background-color: #FFFFFF;
    padding: 24px 20px 0;
    .icon-color {
      color: #99a1af;
    }
    .field-input {
        background-color: #fff;
        border: 1px solid #d1d5dc;
        border-radius: 8px;
        &:focus-within {
            background: rgba(67, 97, 238, 0.05);
            border: 1px solid #4361ee;
        }
    }
    .login-phone {
        display: flex;
        .phone-label {
            width: 140px;
            font-size: 0.388888rem;
            padding: 0.277777rem 0 0.277777rem 0.444444rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            i {
                margin-right: 0.111111rem;
            }
            img {
                width: 8px;
                height: 8px;
            }
        }
        .label-font {
            color: rgba(0, 0, 0, 0.2);
            font-weight: 600;
        }
    }
    .phone-value {
        background-color: #fff;
        border-radius: 8px;
        &:focus-within {
            background: transparent;
        }
    }
    .login-btn {
        background-color: #4361ee;
        border-radius: 6px;
        border:#4361ee;
        margin-top: 25px;
    }
    .field-right-img {
        width: 14px;
        height: 14px;
        display: inherit;
    }
    .forgotPwd-resend {
        color: #4361ee;
    }
    .tips1 {
        margin-bottom: 20px;
        font-size: 13px;
        -webkit-text-size-adjust: none
    }
    .tips2 {
        margin-top: 8px;
        font-size: 12px;
        color: #929292;
        -webkit-text-size-adjust: none
    }
    .error {
        color: #ee0a24;
    }
}
html[dir="rtl"] .PhoneFindPwd {
    .login-phone {
        .phone-label {
            padding: 0.277777rem 0.444444rem 0.277777rem 0;
            flex-direction: row-reverse;
            i {
                margin-right: unset;
                margin-left: 0.111111rem;
            }
        }
    }
    ::v-deep {
        .van-field__control,.van-field__error-message {
            text-align: right;
        }
        .van-field__left-icon {
            margin-right: unset;
            margin-left: 0.111111rem;
        }
    }
}
::v-deep {
    .van-picker-column {
        .van-picker-column__item {
            font-size: 14px;
        }
        .van-picker-column__item--selected {
            font-size: 18px;
            font-weight: 600;
        }
    }
    .van-picker__toolbar {
        .van-picker__cancel {
            color: #000;
        }
        .van-picker__confirm {
            color: #4361ee;
        }
    }
}
</style>